export interface IFileEntry {
  id?: number;
  ten?: string | null;
  tenMoRong?: string | null;
  duongDan?: string | null;
  tenHienThi?: string | null;
}

export const defaultValue: Readonly<IFileEntry> = {};
